<template>
    <div class="cbs-booking-summary">
        <h2>Booking summary</h2>
        <hr />

        <div class="cbs-booking-summary-general">
            <div>
                <div class="cbs-booking-summary-item-title">
                    <i class="fa fa-map-marker" aria-hidden="true"></i> <b>From:</b>
                    <span class="cbs-booking-summary-item-description">
                        {{fromAddress}}
                    </span>
                </div>
            </div>

            <div class="cbs-booking-summary-item" v-if="toAddress">
                <div class="cbs-booking-summary-item-title">
                    <i class="fa fa-map-marker" aria-hidden="true"></i> <b>To:</b>
                    <span class="cbs-booking-summary-item-description">
                        {{toAddress}}
                    </span>
                </div>
            </div>

            <div class="cbs-booking-summary-item" v-if="numberOfHours">
                <div class="cbs-booking-summary-item-title">
                    <i class="fa fa-clock-o" aria-hidden="true"></i> <b>{{numberOfHours}}</b>
                        <span class="cbs-booking-summary-item-description">
                            hours booking
                        </span>
                </div>
            </div>

            <div class="cbs-booking-summary-item">
                <div class="cbs-booking-summary-item-title">
                    <i class="fa fa-calendar" aria-hidden="true"></i> <span class="cbs-booking-summary-item-label">Date / Time:</span>
                </div>
                <div class="cbs-booking-summary-item-description">
                    {{pickupDateTime}}
                </div>
            </div>

            <div class="cbs-booking-summary-item">
                <div class="cbs-booking-summary-item-title">
                    <i class="fa fa-repeat" aria-hidden="true"></i> <span class="cbs-booking-summary-item-label">Est. duration:</span>
                </div>
                <div class="cbs-booking-summary-item-description">
                    {{estDuration}}
                </div>
            </div>

            <div class="cbs-booking-summary-item">
                <div class="cbs-booking-summary-item-title">
                    <i class="fa fa-clock-o" aria-hidden="true"></i> <span class="cbs-booking-summary-item-label">Est. Arrival:</span>
                </div>
                <div class="cbs-booking-summary-item-description">
                    {{estArrivalTime}}
                </div>
            </div>

            <div class="cbs-booking-summary-change-section">
                <a href="#" @click.prevent="goToInitialSelection">Change</a>
            </div>
        </div>

        <div class="cbs-booking-summary-car" v-show="selectedCar.className && currentStep > 2">
            <hr />

            <div class="cbs-booking-summary-item">
                <div class="cbs-booking-summary-item-title">
                    <i class="fa fa-car" aria-hidden="true"></i> <b>Car:</b>
                    <span class="cbs-booking-summary-item-description">
                        {{selectedCar.className}}
                    </span>
                </div>
                <div v-show="selectedCar.equivalent && selectedCar.equivalent !== selectedCar.className"
                     class="cbs-booking-summary-item-description">{{selectedCar.equivalent}}</div>
            </div>

            <div class="cbs-booking-summary-item">
                <div class="cbs-booking-summary-item-title">
                    <i class="fa fa-user" aria-hidden="true"></i> <b>Max Passengers:</b>
                    <span class="cbs-booking-summary-item-description">
                        {{selectedCar.numberOfPassengers}}
                    </span>
                </div>
            </div>

            <div class="cbs-booking-summary-item">
                <div class="cbs-booking-summary-item-title">
                    <i class="fa fa-user" aria-hidden="true"></i> <b>Max Luggages:</b>
                    <span class="cbs-booking-summary-item-description">
                        {{selectedCar.numberOfLuggages}}
                    </span>
                </div>
            </div>

            <div class="cbs-booking-summary-change-section">
                <a href="#" @click.prevent="goToCarSelection">Change</a>
            </div>
        </div>
        <!--<div class="cbs-booking-summary-car" v-show="selectedCar.className && currentStep > 2">
            <hr />
            <h3 class="mb-0">Add coupon:</h3>
            <input type="text" class="form-control" name="promoCode" placeholder="Cupon Code"
                    v-model="promoCode" @keyup.enter="updatePrice()">
            <div class="text-center">
                <button type="button" class="btn btn-success btn-sm apply-button" @click="updatePrice()">Apply</button>
            </div>
        </div>-->
        <div class="cbs-booking-summary-price" v-show="selectedCar.carPrice && currentStep > 2">
            <hr />
                        
            <div class="cbs-booking-summary-item" v-if="selectedCar.extras">
                <div class="cbs-booking-summary-item-price">
                    <div>
                        <div class="clear-both">
                            <div class="item-name inline-block">Car price:</div>
                            <div class="item-value inline-block float-right">{{selectedCar.carPrice | round(2,true)}} <span v-html="selectedCar.currencySymbol"></span></div>
                        </div>
                        <div class="clear-both" v-for="extra in selectedCar.extras">
                            <div class="item-name inline-block" v-html="extra.descriptionHtml + ':'"></div>
                            <div class="item-value inline-block float-right">{{extra.companyAmount | round(2,true)}} <span v-html="selectedCar.currencySymbol"></span></div>
                        </div>
                        <div class="clear-both" v-show="selectedCar.taxValue > 0">
                            <div class="item-name inline-block">Taxes:</div>
                            <div class="item-value inline-block float-right">{{selectedCar.taxValue | round(2,true)}} <span v-html="selectedCar.currencySymbol"></span></div>
                        </div>
                    </div>
                    <div class="clear-both cbs-booking-summary-total-price">
                        <div class="item-name inline-block">Total:</div>
                        <div class="item-value inline-block float-right">{{selectedCar.totalPrice | round(2,true) }} <span v-html="selectedCar.currencySymbol"></span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    import { round } from "../utils/filters.js"

    export default {
        name: "BookingSummary",
        components: {},
        data: function () {
            return { }
        },
        computed: {
            currentStep: function () { return this.$store.state.bookingInfo.currentStep; },
            fromAddress: function () {
                var addressName = this.$store.state.bookingInfo.general.pickupAddress.location.addressName;
                var address = this.$store.state.bookingInfo.general.pickupAddress.location.address;
                if (address == addressName) return address;

                return addressName + " (" + address + ")";
            },
            toAddress: function () {
                var dropOffAddress = this.$store.state.bookingInfo.general.dropOffAddress;
                if (!dropOffAddress || !dropOffAddress.location) return "";

                var addressName = this.$store.state.bookingInfo.general.dropOffAddress.location.addressName;
                var address = this.$store.state.bookingInfo.general.dropOffAddress.location.address;
                if (address == addressName) return address;

                return addressName + " (" + address + ")";
            },
            numberOfHours: function () {
                var numberOfHoursBooked = this.$store.state.bookingInfo.general.durationInHours;
                return numberOfHoursBooked;
            },
            pickupDateTime: function () {
                var datePart = this.$store.state.bookingInfo.general.pickupDate;
                var timePart = this.$store.state.bookingInfo.general.pickupTime;
                if (!datePart || !timePart) return "";
                var parsedDate = moment(datePart + " " + timePart, "DD-MM-YYYY HH:mm");
                return parsedDate.format("HH:mm A on DD-MM-YYYY");
            },
            estDuration: function () {
                var result = "";
                var minutes = this.$store.state.bookingInfo.general.timeInMinutes;
                var hours = Math.floor(minutes / 60); //hours
                if (hours > 1) result += hours + " hours ";
                else if (hours > 0) result += hours + " hour ";

                minutes = minutes - (hours * 60);
                if (result.length > 0 && minutes > 0) result += " and ";

                if (minutes > 1) result += minutes + " minutes";
                else if (minutes > 0) result += minutes + " minute";

                return result;
            },
            estArrivalTime: function () {
                var timeInMinutes = this.$store.state.bookingInfo.general.timeInMinutes;
                var datePart = this.$store.state.bookingInfo.general.pickupDate;
                var timePart = this.$store.state.bookingInfo.general.pickupTime;
                if (!datePart || !timePart) return "";
                var parsedDate = moment(datePart + " " + timePart, "DD-MM-YYYY HH:mm");
                parsedDate = parsedDate.add(timeInMinutes, 'minutes');
                return parsedDate.format("HH:mm A on DD-MM-YYYY");
            },
            selectedCar: {
                get: function () {
                    var car = this.$store.state.bookingInfo.selectedCar;
                    //console.log(car);
                    if (!car) return {};
                    return car;
                }
            },
            totalPrice: function () {
                if (!this.selectedCar.extras)
                    return this.selectedCar.price;
                else {
                    var sum = this.selectedCar.price;
                    sum += this.selectedCar.extras.reduce(function (sum, item) { return sum + item.companyAmount; }, 0);
                    return sum;
                }
            },
            promoCode: {
                get: function () {
                    return this.$store.state.bookingInfo.general.promoCode;
                },
                set: function (value) {
                    this.$store.commit('setPromoCode', value);
                }
            },
        },
        methods: {
            goToCarSelection: function () {
                this.$store.commit("setCurrentStep", 2);
            },
            goToInitialSelection: function () {
                this.$store.commit('setCurrentStep', 1);
            },
            updatePrice: function () {
                //this.$store.commit('setPromoCode', this.promoCode);
                this.$store.dispatch('updateBookingPrice');
            }
        },
        filters: {
            round: round
        }
    }
</script>

<style>
    .cbs-booking-summary {
        background-color: #fff;
        padding: 10px;
    }

        .cbs-booking-summary h2 {
            display: inline-block;
            margin-bottom: 0px;
            font-size: 18px;
        }

        .cbs-booking-summary a {
            text-decoration: underline;
        }

        .cbs-booking-summary .cbs-booking-summary-general,
        .cbs-booking-summary .cbs-booking-summary-car,
        .cbs-booking-summary .cbs-booking-summary-price {
            margin-top: 15px;
        }

        .cbs-booking-summary .cbs-booking-summary-item {
            margin-top: 20px;
        }

        .cbs-booking-summary .cbs-booking-summary-item-title {
            color: black;
        }

        .cbs-booking-summary .cbs-booking-summary-item-label {
            font-weight: bold;
        }

        .cbs-booking-summary .cbs-booking-summary-item-title i {
            padding-right: 5px;
        }

        .cbs-booking-summary .cbs-booking-summary-item-description {
            font-size: 14px;
        }

        .cbs-booking-summary .cbs-booking-summary-change-section {
            text-align: right;
        }

        .cbs-booking-summary .cbs-booking-summary-item-price {
            color: #ab8b64;
            font-size: 20px;           
        }

        .cbs-booking-summary .cbs-booking-summary-total-price {
            font-weight: bold;
            border-top: 1px solid #ab8b64;
        }

        .cbs-booking-summary .apply-button {
            margin-top: 10px;
            background-color: #24b47e;
            box-shadow: none !important;
        }

            .cbs-booking-summary .cbs-booking-summary-item-price-amount { font-size: 28px; }
        .cbs-booking-summary .cbs-booking-summary-item-price-currency { margin-right: 10px; }
</style>